import React, {lazy, Suspense} from 'react'
import { Route, Switch } from 'react-router-dom';
import { pageProps, pageComponents } from 'src/config/page-index'
import { setGlobal, getGlobal, AdminLogin, apiGet, helpers, Loading } from 'launchpad'
import { getSlug } from '_helpers';
import { _ } from 'underscore'
import Error404 from 'pages/Error404.jsx';
import Home from 'pages/Home.jsx';
import config from 'config'
import Stub from 'pages/Stub'



// import LandingPage, {Landing} from 'pages/Landing';
import ProductCategory from 'templates/ProductCategory';
import Product from 'templates/Product';
import { loadPages } from 'pages/admin/PageManager'
import CustomPage from 'pages/CustomPage'
import { SearchPage } from 'templates/Search'


let refreshFunctions = []

// use these functions to register functions which should be called whenever
// routes are refreshed, and where those routes are stored
const registerRefreshFunction = (fn) => {
  if(!refreshFunctions.includes(fn)) refreshFunctions.push(fn)
}




/* ==========================================
    DEFINE ROUTES HERE

    Associate a route with either a component name (src/pages directory only),
    a render function, or an actual component to render the page

   ========================================== */



const custom_routes = {
  // e.g.:
  // '/projects/:id': {title: 'Project Detail', component: 'ProjectDetail'},
}


let additionalRoutes = {}




// NOTE: not sure if this is the best pattern (hook/register approach) but it's
// clean-ish and easy for now. If we keep it we should document it at some point.

// get map of custom pages and create routes
registerRefreshFunction(refresh => {
  loadPages(pages => {
    let custom_routes = {}
    pages.forEach(p => {
      if(!p.url.startsWith('/')) p.url = '/'+p.url
      custom_routes[p.url] = {type: 'custom', title: p.title, component: () => <CustomPage page={p} />}
    })
    additionalRoutes.customRoutes = custom_routes
    refresh()
  }, true)
})


// get map of products and break out into routes/index
registerRefreshFunction(refresh => {
  let product_routes = {}
  let product_list = []
  let category_map = {}
  apiGet('product-tree').then(routes => {
    Object.keys(routes).forEach(key => {
      let category = routes[key]

      if(!category.url.startsWith('/')) category.url = '/'+category.url
      product_routes[category.url] = {type: 'product', title: category.name, component: () => <ProductCategory category={category} /> }
      let subcats = category.subcategories || []
      if(category.name == 'Wood Frames') subcats = (['All Wood Frames']).concat(subcats)
      subcats = subcats.map(s => {
        const slug = getSlug(s)
        return {
          _id: slug,
          name: s,
          url: slug
        }
      })

      subcats.forEach(s => {
        product_routes[`${category.url}/${s.url}-category`] = {
          type: 'product',
          title: s.name,
          component: () => <ProductCategory category={category} subcategory={s} />
        }
      })
      category.products.forEach(product => {
        if(!category_map[product.category._id]) category_map[product.category._id] = product.category
        product_list.push(product)
        const route = category.url+'/'+product.url;
        product_routes[route] = {type: 'product', title: product.name, component: () => <Product id={product._id} /> }
      })
    })
    additionalRoutes.productRoutes = product_routes
    setGlobal({ product_list, category_map })
    refresh()
  })
})



// code below will translate objects/functions above into
// routes and fill in auto-generated routes if available



// modifiable copy of custom_routes
let route_map = Object.assign({}, custom_routes)


// get routes generated by `npm run crawl` (see launchpad/devops/crawl.js)
let autoRoutes = {}
try {
  const routeList = require('launchpad/devops/_generated/valid-routes').default

  const delimiter = config.existing_url.replace('http://', '').replace('https://', '')
  routeList.forEach(route => {
    route = route.split(delimiter)[1];
    if(route && route != '/' && !route.includes(['"', '&', '?', '#'])){

// NOTE: uncomment this line to include stubbed routes from the crawler
      //autoRoutes[route] = Stub

    }
  })
} catch(e) {/* assume auto-routes doesn't exist */}



// tree will be kept here once calculated for faster rendering
let cachedTree = null

export const getCachedTree = (options) => {
  if(cachedTree) return cachedTree.tree
  return getRouteTree().tree
}

export const getCachedTitles = (options) => {
  if(cachedTree) return cachedTree.titleMap
  return getRouteTree().titleMap
}

export const getCachedRouteInfo = (options) => {
  if(cachedTree) return cachedTree.infoMap
  return getRouteTree().infoMap
}

export const getCachedMap = (options) => {
  if(cachedTree) return cachedTree.route_map
  return getRouteTree().route_map
}

export const getRouteTree = (options) => {
  options = options || {}

  // return cached tree if it exists unless a hard refresh is requested
  if(cachedTree && !options.hardRefresh) return cachedTree

  // reset route map
  route_map = Object.assign({}, custom_routes)

  // add routes from the page index
  Object.keys(pageProps).forEach(key => {
    const p = pageProps[key]
    if(p.id){
      let route = Object.assign(p, {
        component: key,
        title: p.launchpad_title || helpers.getTitle(p.id), id: p.id,
        type: p.launchpad_type || 'main'
      })
      route_map[route.url] = route
    }
  })

  // combine indexed routes with autoRoutes (from crawler), overriding auto-routes with route_map
  route_map = Object.assign({}, autoRoutes, route_map)

  // pull in and integrate any registered route objects
  Object.keys(additionalRoutes).forEach(m => route_map = Object.assign({}, route_map, additionalRoutes[m] || {}))

  let titleMap = {}
  let infoMap = {}

  // returns a link object usable by page index and menus
  const linkObj = (base, url, type) => {
    let obj = {
      title: (route_map[url] && route_map[url].title) || helpers.getTitle(base),
      id: (route_map[url] && route_map[url].id),
      base: base,
      types: [],
      children: [],
      links: []
    }
    if(url){
      obj.url = url
    }
    if(type){
      obj.types = [type]
    }

    obj.addChild = function(child) {
      const excluded = ['/home', '/']
      // short circuit, don't add home page to any tree
      if(excluded.includes(child.url)) return

      this.pushLink(child.url)
      child.types.forEach(t => {
        if(!this.types.includes(t)) this.types.push(t)
      })

      child.parent = this
      titleMap[child.url] = child.title
      if(child.id){
        infoMap[child.id] = {
          url: child.url,
          title: child.title,
          data: route_map[child.url]
        }
      }
      this.children.push(child)
    }

    obj.pushLink = function(link) {
      if(link && !this.links.find(l => l == link)) this.links.push(link)
      if(this.parent) this.parent.pushLink(link)
    }

    return obj
  }

  let route_tree = linkObj('/', '/')


  // adds dissected route to tree (recursive, unpacks children)
  const addToTree = (parts, url, parent, type) => {
    //if(parent) console.log('parent', parent)
    if(!parent) parent = route_tree

    if(parts.length < 2) {
      let link = parent.children.find(link => link.base == parts[0])
      if(link){
        link.isPage = true
      } else {
        parent.addChild(linkObj(parts[0], url, type))
      }
    } else if(parts && parts.length) {
      let newParent = parent.children.find(link => link.base == parts[0])
      if(!newParent){
        newParent = linkObj(parts[0], null, type)
        parent.addChild(newParent, url)
      }
      addToTree(parts.slice(1), url, newParent, type)
      //addToTree(parts, url)
    }
  }

  // take each route and feed it through the pipeline to generate a tree
  Object.keys(route_map).forEach(key => {
    let url = key
    const link = route_map[key]

    let type = link.type || 'main'

    const parts = url.split('/').filter(part => part)
    if(parts.length && !parts[parts.length - 1].startsWith(":")){
      addToTree(parts, url, null, type)
    }
  })

  // recursively sort the tree alphabetically and add home page to top level
  const sortTree = (tree) => {

    if(tree.children){
      tree.children = _.sortBy(tree.children, 'url')
    }
    tree.children = tree.children.map(tree => sortTree(tree))
    if(tree.base == '/') {
      tree.children = [{base: 'Home', url: '/', children: []}].concat(tree.children)
    }
    return tree
  }

  //setGlobal({ titleMap })
  const completeTree = {
    tree: sortTree(route_tree),
    titleMap,
    infoMap,
    route_map
  }
  cachedTree = completeTree
  return completeTree
}




export const refreshRoutes = async () => {
  if(getGlobal('AutoRoutes')) {
    return await getGlobal('AutoRoutes').refreshRoutes()
  } else {
    return new Promise((resolve, reject) => reject())
  }
}

export const getValidRoutes = () => {
  return getGlobal('AutoRoutes') && getGlobal('AutoRoutes').state.validUrls
}

// TODO: maybe implement this for better route refreshing
let routeListeners = []
export const registerRouteListener = (l) => routeListeners.push(l)
export const unregisterRouteListener = (l) => routeListeners = routeListeners.filter(x => x != l)


export default class AutoRoutes extends React.Component {
  state = {
    Routes: [],
    validUrls: [],
    activeLinks: [],
    routesLoaded: false
  }

  componentDidMount() {
    setGlobal({AutoRoutes: this})
    window.getRouteCSV = this.getRouteCSV
  }

  // callable externally (see above)
  refreshRoutes = () => {
    return this.loadRoutes()
  }

  get route_map() {
    return route_map
  }

  get route_list() {
    let routes = `"Name", "Url"
`
    Object.keys(route_map).forEach(x => routes += `"${route_map[x].title}", "${x}"\n`)
    return routes
  }

  getRouteCSV = () => {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(this.route_list));
    element.setAttribute('download', 'routes.csv');

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  loadRoutes = () => {
    return new Promise((resolve, reject) => {
      additionalRoutes = {}
      let loaded = 0
      const total = refreshFunctions.length
      refreshFunctions.forEach(fn => fn(() => {
          loaded += 1;
          if(loaded == total) {
            this.parseRoutes()
            resolve()
          }
        })
      )
    })

    //refreshFunctions.forEach(async fn => fn(cb))
  }

  parseRoutes = () => {
    let route_tree = getRouteTree({hardRefresh: true}).tree

    let needsUpdate = false

    let validUrls = []
    route_tree.links.forEach(l => {
      validUrls.push(l)
      if(!this.state.validUrls.includes(l)){
        needsUpdate = true
      }
    })
    if(needsUpdate){
      this.setState({ Routes })
      setGlobal({routeTree: route_tree})
    } else {
      return
    }
    this.setState({ validUrls })

    let route_components = {}

    const getRouteComponent = (route) => {
      if(typeof route == 'string'){
        //let Renderer = lazy(() => import('pages/' + route + '.jsx'))
        const Renderer = pageComponents[route]
        return () => <Renderer fallback={<main><Loading active={true} /></main>}/>
        return () => <Suspense fallback={<main><Loading active={true} /></main>}><Renderer key={route} /></Suspense>
      } else if(typeof route == 'function') {
        return route
      } else {
        if(route.component){
          return getRouteComponent(route.component)
        } else {
          return route
        }
      }
    }


    Object.keys(route_map).forEach(key => {
      const route = route_map[key]
      route_components[key] = getRouteComponent(route)
    })

    let Routes = Object.keys(route_components).map((route, i) => {
      let props = {}
      if(typeof route_components[route] != 'function'){
        props.component = route_components[route]
      } else {
        props.render = route_components[route]
      }
      //console.log(route_components[route])
      return <Route key={route+i} exact={!route.includes(':')} path={route} {...props} />
    });

    // append basic launchpad routes
    Routes = Routes.concat([
      // <Route key = 'about' exact path='/about' component={About} />,
      <Route key='home' exact path="/" component={Home}/>,
      <Route key='admin-login' exact path="/admin" component={AdminLogin}/>,
      <Route key='search' exact path='/search' component={SearchPage}/>,
      // it's important that this route is always at the end!!
      <Route key='404' component={Error404} />
    ])
    this.setState({ Routes, routesLoaded: true }, () => {
      // wait 2 seconds after routes fully loaded and notify that render is ready
      // (for prerender.io)
      setTimeout(() => window.prerenderReady = true, 2000)
    })
  }

  render() {
    const placeholderStyle = {flex: 1, position: 'relative', textAlign: 'center'}
    if(!this.state.routesLoaded) return <div style={placeholderStyle}><Loading active={true} /></div>
    return <Switch>
      {this.state.Routes}
    </Switch>
  }
}

if(module.hot) {
  module.hot.accept()
  module.hot.accept('src/config/page-index', refreshRoutes)
}
